export const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i;

export default function urlify(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/gi;

  let result = text;
  result = result.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
  result = result.replace(emailRegex, '<a href="mailto:$1">$1</a>');

  return result;
}
